import { useLocalStorage } from 'react-use';

import { IValidatedBasket } from '~/lib/data-contract';

export const BASKET_STORAGE_DATA = 'RDG_BASKET_STORAGE_DATA';

interface MinimalBasketData {
	id: string;
	items: Array<{
		sku: string;
		quantity: number;
	}>;
}

export const useBasketStorage = () => {
	const [storedBasket, setStoredRawBasket, clearStoredBasket] = useLocalStorage<MinimalBasketData | IValidatedBasket>(BASKET_STORAGE_DATA);

	const setStoredBasket = (basket: IValidatedBasket) => {
		if (!basket || !basket.basket) return;

		const minimalData: MinimalBasketData = {
			id: basket.id,
			items:
				basket.basket.lineItems?.map((item) => ({
					sku: item.variation.sku,
					quantity: item.quantity,
				})) || [],
		};

		setStoredRawBasket(minimalData);
	};

	return {
		setStoredBasket,
		storedBasket,
		clearStoredBasket,
	};
};
